import moment from 'moment';
import { initGrid } from 'utils/grid/grid';
import { downloadEarningsHistoryReport, fetchEarningsHistory } from 'dashboard/actions/earnings-history/earnings-history.actions';
import { fetchInvoiceDatesDictionary } from 'app/actions/dictionaries/invoice-dates-dictionary.actions';
import * as api from 'dashboard/resources/earnings.api';
import template from './earnings-history.html';

const mapStateToThis = ({ session, config, earningsHistory, dictionary }) => {
  const { serverTime, retailer, locale } = session;
  const { pageSizeKey, defaultPageSizes, sortColumnKey, showCompensationCategoryDetails } = config;
  const { data, isLoading } = earningsHistory;
  const { invoiceDates } = dictionary;
  const terms = dictionary.terms[locale];

  return {
    serverTime,
    retailer,
    pageSizeKey,
    defaultPageSizes,
    sortColumnKey,
    showCompensationCategoryDetails,
    invoiceDates,
    data,
    isLoading,
    terms,
  };
};

const mapDispatchToThis = {
  fetchInvoiceDatesDictionary,
  downloadEarningsHistoryReport,
  fetchEarningsHistory,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state', 'tableService')
class EarningsHistoryController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    await this.fetchInvoiceDatesDictionary(this.retailerId);
    this.tableConfig = this.tableService.initConfig({ configName: 'earningsHistory' });
    this.headers = this.tableConfig.getHeaders(this.getHeaders());
    this.defaultParams = {
      [this.pageSizeKey]: this.defaultPageSizes[2],
    };
    this.gridModel = await initGrid(this.fetchEarningsHistory, this.defaultParams);
    this.initializeFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  preserveFilters() {
    this.preservedFilters = { ...this.gridModel.pagingModel.filters };
  }

  initializeFilters() {
    this.gridModel.pagingModel.filters = {
      invoiceEndDate: this.invoiceDates[0].id,
      retailerId: this.retailerId,
    };

    this.setInvoiceDateRange();
  }

  search() {
    this.maintenance = false;
    this.gridModel
      .applyFilters()
      .then(() => {
        this.preserveFilters();
      })
      .catch((err) => {
        console.error('EARNINGS_HISTORY', err);
        this.maintenance = true;
      });
  }

  clearFilter() {
    this.initializeFilters();
    this.search();
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Source'),
        field: 'source',
      },
      this.showCompensationCategoryDetails
        ? {
            /// {{ instant }} is Lottery term using to determine Instant games.
            text: this.gettextCatalog.getString('{{ instant }} Games', { instant: this.terms.INSTANT.singular }),
            field: 'instantGames',
          }
        : null,
      this.showCompensationCategoryDetails
        ? {
            /// {{ instant }} is Lottery term using to determine Instant games.
            text: this.gettextCatalog.getString('e{{ instant }}', { instant: this.terms.INSTANT.plural }),
            field: 'eInstants',
          }
        : null,
      this.showCompensationCategoryDetails
        ? {
            /// {{ draw }} is Lottery term using to determine Draw games.
            text: this.gettextCatalog.getString('{{ draw }} Games', { draw: this.terms.DRAW.singular }),
            field: 'drawGames',
          }
        : null,
      {
        text: this.gettextCatalog.getString('Total'),
        field: 'total',
      },
    ];
  }

  downloadReport(format) {
    const params = {
      ...this.gridModel.pagingModel,
      filters: this.preservedFilters,
      extension: format,
      pageSize: 0, // BE contract - pageSize = 0 triggers exporting entire data set
    };
    return this.downloadEarningsHistoryReport(params);
  }

  setInvoiceDateRange() {
    const earningsInvoiceDate = this.invoiceDates.find(
      (invoiceDate) => invoiceDate.id === this.gridModel.pagingModel.filters.invoiceEndDate
    );
    this.invoiceDateRange = earningsInvoiceDate ? earningsInvoiceDate.value : '-';
  }
}

export default class EarningsHistoryComponent {
  constructor() {
    this.template = template;
    this.controller = EarningsHistoryController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/earnings/components/earnings-history-component.js